import { Text } from 'common-components'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import PremiumCrownIcon from 'assets/svgr-icons/Premium_Crown.svg'

interface IProps {
  $isUserTtsCreditsLoading: boolean
  $isTtsGenerationLoading: boolean
}

export const CreditsLimitContainer = styled.div<IProps>`
  position: relative;
  width: 100%;
  padding: 6px 32px;

  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;

  &:hover {
    background-color: ${COLORS.primaryLight};
  }

  transition: background-color 0.3s;
  cursor: pointer;

  ${({ $isTtsGenerationLoading }) =>
    $isTtsGenerationLoading &&
    css`
      pointer-events: none;
      opacity: 0.4 !important;
    `}

  ${({ $isUserTtsCreditsLoading }) =>
    $isUserTtsCreditsLoading &&
    css`
      min-height: 30px;
      padding: 0;
      background-color: ${COLORS.primaryLight};
    `}
`
export const PremiumIcon = styled(PremiumCrownIcon)`
  position: absolute;
  top: -2px;
  right: 9px;
  z-index: 2;
`

export const LimitText = styled(Text)`
  .highlightedText {
    color: ${COLORS.primaryDark};
    text-decoration: underline;
  }
`
